(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9725,2576,5124,949,7357],{

/***/ 95387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ unify; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Elevation/index.ts + 2 modules
var Elevation = __webpack_require__(33606);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(95576);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(62014);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(34449);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/HeroMobile.png
var HeroMobile = __webpack_require__(49956);
var HeroMobile_default = /*#__PURE__*/__webpack_require__.n(HeroMobile);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/HeroMobile@2x.png
var HeroMobile_2x = __webpack_require__(54297);
var HeroMobile_2x_default = /*#__PURE__*/__webpack_require__.n(HeroMobile_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/HeroMobile.webp
var assets_HeroMobile = __webpack_require__(56400);
var assets_HeroMobile_default = /*#__PURE__*/__webpack_require__.n(assets_HeroMobile);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/Hero/assets/HeroMobile@2x.webp
var assets_HeroMobile_2x = __webpack_require__(17606);
var assets_HeroMobile_2x_default = /*#__PURE__*/__webpack_require__.n(assets_HeroMobile_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/Hero/HeroImage.tsx













var HeroImage = function HeroImage(_ref) {
  var alt = _ref.alt;

  var _useTheme = (0,emotion_element_6a883da9_browser_esm.u)(),
      breakpoints = _useTheme.breakpoints;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        media: breakpoints.down("md", false),
        srcSet: "".concat((assets_HeroMobile_default()), ", ").concat((assets_HeroMobile_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/png",
        media: breakpoints.down("md", false),
        srcSet: "".concat((HeroMobile_default()), " ").concat((HeroMobile_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        media: breakpoints.up("md", false),
        srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "640",
        height: "441",
        src: (Hero_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/Hero/Hero.tsx







var copy = {
  overline: "Unify",
  heading: "Get a complete view of your customer",
  description: "Unify real-time customer data interactions with data from your warehouse and empower any team within the business to use trusted data across any platform and channel to build 1:1 personalized experiences at scale."
};
var FORM_ID = "profiles-demo-request";

var Hero_Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            tag: "h5",
            variant: "h5",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
            isProgressive: true,
            customFormIdentifier: FORM_ID,
            customTrackingType: FORM_ID,
            successMessageAppearance: "twilioLight"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {
          alt: "Illustration: ".concat(copy.heading)
        })
      })]
    })
  });
};

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e3da1qx0"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/LinkedProfiles/assets/LinkedProfiles@2x.png
var LinkedProfiles_2x = __webpack_require__(63512);
var LinkedProfiles_2x_default = /*#__PURE__*/__webpack_require__.n(LinkedProfiles_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/LinkedProfiles/assets/LinkedProfiles.webp
var assets_LinkedProfiles = __webpack_require__(94686);
var LinkedProfiles_default = /*#__PURE__*/__webpack_require__.n(assets_LinkedProfiles);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/LinkedProfiles/assets/LinkedProfiles@2x.webp
var assets_LinkedProfiles_2x = __webpack_require__(31636);
var assets_LinkedProfiles_2x_default = /*#__PURE__*/__webpack_require__.n(assets_LinkedProfiles_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/LinkedProfiles/LinkedProfilesImage.tsx








var LinkedProfiles = function LinkedProfiles(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((LinkedProfiles_default()), ", ").concat((assets_LinkedProfiles_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "652",
        height: "508",
        src: (LinkedProfiles_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var LinkedProfilesImage = (LinkedProfiles);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/LinkedProfiles/LinkedProfiles.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var LinkedProfiles_copy = {
  heading: "Enable any data in the warehouse to be activated in real time with Linked Profiles",
  description: "Linked Profiles helps data teams map a Data Graph that brings together the power of the Segment real time customer data platform with the complete set of business records stored in data warehouses and lakes\u2014 promoting a deeper understanding of each customer, the buying groups they are associated with and their interactions with your business.",
  buttonText: "Sign up for the Beta",
  buttonUrl: "/linked-profiles-beta/"
};

var LinkedProfiles_LinkedProfiles = function LinkedProfiles() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedProfilesImage, {
        alt: "Illustration: ".concat(LinkedProfiles_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: LinkedProfiles_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: LinkedProfiles_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(LinkedProfiles_copy.buttonUrl, pageConfig),
          children: LinkedProfiles_copy.buttonText
        })]
      })
    })]
  });
};

/* harmony default export */ var components_LinkedProfiles_LinkedProfiles = (LinkedProfiles_LinkedProfiles);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e95wtwv1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e95wtwv0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UseAI/assets/UseAI@2x.png
var UseAI_2x = __webpack_require__(224);
var UseAI_2x_default = /*#__PURE__*/__webpack_require__.n(UseAI_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UseAI/assets/UseAI.webp
var UseAI = __webpack_require__(1864);
var UseAI_default = /*#__PURE__*/__webpack_require__.n(UseAI);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UseAI/assets/UseAI@2x.webp
var assets_UseAI_2x = __webpack_require__(89620);
var assets_UseAI_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UseAI_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/UseAI/UseAIImage.tsx








var UseAIImage = function UseAIImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((UseAI_default()), ", ").concat((assets_UseAI_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "827",
        height: "810",
        src: (UseAI_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var UseAI_UseAIImage = (UseAIImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/UseAI/UseAI.tsx


function UseAI_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var UseAI_copy = {
  heading: "Use AI to turn every customer interaction into a unique customer experience",
  description: "Segment makes it easier than ever to understand, predict, generate, and engage each individual customer in real-time and at scale.",
  buttonText: "Learn more",
  buttonUrl: "/solutions/ai/"
};

var UseAI_UseAI = function UseAI() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseAI_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UseAI_StyledSectionBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseAI_UseAIImage, {
          alt: "Illustration: ".concat(UseAI_copy.heading)
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseAI_StyledCopy, {
        alignSelf: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            variant: "h2",
            children: UseAI_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: UseAI_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(UseAI_copy.buttonUrl, pageConfig),
            children: UseAI_copy.buttonText
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var components_UseAI_UseAI = (UseAI_UseAI);

var UseAI_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eq1caty2"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var UseAI_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eq1caty1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var UseAI_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "eq1caty0"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/TrackInteractions/assets/TrackInteractions@2x.png
var TrackInteractions_2x = __webpack_require__(48202);
var TrackInteractions_2x_default = /*#__PURE__*/__webpack_require__.n(TrackInteractions_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/TrackInteractions/assets/TrackInteractions.webp
var TrackInteractions = __webpack_require__(95638);
var TrackInteractions_default = /*#__PURE__*/__webpack_require__.n(TrackInteractions);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/TrackInteractions/assets/TrackInteractions@2x.webp
var assets_TrackInteractions_2x = __webpack_require__(15798);
var assets_TrackInteractions_2x_default = /*#__PURE__*/__webpack_require__.n(assets_TrackInteractions_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/TrackInteractions/TrackInteractionsImage.tsx








var TrackInteractionsImage = function TrackInteractionsImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((TrackInteractions_default()), ", ").concat((assets_TrackInteractions_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "624",
        height: "542",
        src: (TrackInteractions_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var TrackInteractions_TrackInteractionsImage = (TrackInteractionsImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/TrackInteractions/TrackInteractions.tsx


function TrackInteractions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var TrackInteractions_copy = {
  heading: "Track every interaction in real time",
  description: "Gain a deep understanding of your customer behavior as it evolves in real time across web, mobile, server, and third-party touchpoints."
};

var TrackInteractions_TrackInteractions = function TrackInteractions() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackInteractions_StyledSectionBase, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrackInteractions_TrackInteractionsImage, {
        alt: "Illustration: ".concat(TrackInteractions_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrackInteractions_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: TrackInteractions_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: TrackInteractions_copy.description
        })]
      })
    })]
  });
};

/* harmony default export */ var components_TrackInteractions_TrackInteractions = (TrackInteractions_TrackInteractions);

var TrackInteractions_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eh5vt611"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var TrackInteractions_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "eh5vt610"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/GetHistory/assets/GetHistory@2x.png
var GetHistory_2x = __webpack_require__(23611);
var GetHistory_2x_default = /*#__PURE__*/__webpack_require__.n(GetHistory_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/GetHistory/assets/GetHistory.webp
var GetHistory = __webpack_require__(9979);
var GetHistory_default = /*#__PURE__*/__webpack_require__.n(GetHistory);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/GetHistory/assets/GetHistory@2x.webp
var assets_GetHistory_2x = __webpack_require__(86975);
var assets_GetHistory_2x_default = /*#__PURE__*/__webpack_require__.n(assets_GetHistory_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/GetHistory/GetHistoryImage.tsx








var GetHistoryImage = function GetHistoryImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((GetHistory_default()), ", ").concat((assets_GetHistory_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "514",
        height: "542",
        src: (GetHistory_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var GetHistory_GetHistoryImage = (GetHistoryImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/GetHistory/GetHistory.tsx


function GetHistory_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var GetHistory_copy = {
  heading: "Get a holistic view of each customer with identity resolution",
  description: "Explore all your user profiles in one place. Stitch together each customer\u2019s journey between multiple user sessions and devices with deterministic identity resolution, while enabling centralized privacy and governance."
};

var GetHistory_GetHistory = function GetHistory() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetHistory_StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetHistory_GetHistoryImage, {
        alt: "Illustration: ".concat(GetHistory_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetHistory_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: GetHistory_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: GetHistory_copy.description
        })]
      })
    })]
  });
};

/* harmony default export */ var components_GetHistory_GetHistory = (GetHistory_GetHistory);

var GetHistory_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e17t8if61"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var GetHistory_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e17t8if60"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/PowerPersonalization/assets/PowerPersonalization@2x.png
var PowerPersonalization_2x = __webpack_require__(5196);
var PowerPersonalization_2x_default = /*#__PURE__*/__webpack_require__.n(PowerPersonalization_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/PowerPersonalization/assets/PowerPersonalization.webp
var PowerPersonalization = __webpack_require__(4074);
var PowerPersonalization_default = /*#__PURE__*/__webpack_require__.n(PowerPersonalization);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/PowerPersonalization/assets/PowerPersonalization@2x.webp
var assets_PowerPersonalization_2x = __webpack_require__(81927);
var assets_PowerPersonalization_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PowerPersonalization_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/PowerPersonalization/PowerPersonalizationImage.tsx








var PowerPersonalizationImage = function PowerPersonalizationImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((PowerPersonalization_default()), ", ").concat((assets_PowerPersonalization_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "544",
        height: "542",
        src: (PowerPersonalization_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var PowerPersonalization_PowerPersonalizationImage = (PowerPersonalizationImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/PowerPersonalization/PowerPersonalization.tsx


function PowerPersonalization_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var PowerPersonalization_copy = {
  heading: "Power personalization with Profile API",
  description: "Query your user profile in real time to build in-app recommendations, empower your sales and support teams with complete customer context, and create personalized marketing campaigns."
};

var PowerPersonalization_PowerPersonalization = function PowerPersonalization() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PowerPersonalization_StyledSectionBase, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PowerPersonalization_PowerPersonalizationImage, {
        alt: "Illustration: ".concat(PowerPersonalization_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PowerPersonalization_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: PowerPersonalization_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: PowerPersonalization_copy.description
        })]
      })
    })]
  });
};

/* harmony default export */ var components_PowerPersonalization_PowerPersonalization = (PowerPersonalization_PowerPersonalization);

var PowerPersonalization_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11r90hw1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var PowerPersonalization_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e11r90hw0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UnlockAnalytics/assets/UnlockAnalytics@2x.png
var UnlockAnalytics_2x = __webpack_require__(34776);
var UnlockAnalytics_2x_default = /*#__PURE__*/__webpack_require__.n(UnlockAnalytics_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UnlockAnalytics/assets/UnlockAnalytics.webp
var UnlockAnalytics = __webpack_require__(69373);
var UnlockAnalytics_default = /*#__PURE__*/__webpack_require__.n(UnlockAnalytics);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/UnlockAnalytics/assets/UnlockAnalytics@2x.webp
var assets_UnlockAnalytics_2x = __webpack_require__(18154);
var assets_UnlockAnalytics_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UnlockAnalytics_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/UnlockAnalytics/UnlockAnalyticsImage.tsx








var UnlockAnalyticsImage = function UnlockAnalyticsImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((UnlockAnalytics_default()), ", ").concat((assets_UnlockAnalytics_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "563",
        height: "409",
        src: (UnlockAnalytics_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var UnlockAnalytics_UnlockAnalyticsImage = (UnlockAnalyticsImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/UnlockAnalytics/UnlockAnalytics.tsx


function UnlockAnalytics_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var UnlockAnalytics_copy = {
  heading: "Unlock advanced analytics with Profiles Sync",
  description: "Access all of the Segment real-time profile data in your warehouse to build data models and machine learning models that can be used in campaigns to lower customer acquisition costs, increase lifetime value, and inspire engagement."
};
var UnlockAnalytics_link = {
  href: "/product/profiles-sync/",
  text: "Explore Profiles Sync"
};

var UnlockAnalytics_UnlockAnalytics = function UnlockAnalytics() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UnlockAnalytics_StyledSectionBase, {
    variant: "2Col",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnlockAnalytics_UnlockAnalyticsImage, {
        alt: "Illustration: ".concat(UnlockAnalytics_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnlockAnalytics_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: UnlockAnalytics_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: UnlockAnalytics_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(UnlockAnalytics_link.href, pageConfig),
          children: UnlockAnalytics_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var components_UnlockAnalytics_UnlockAnalytics = (UnlockAnalytics_UnlockAnalytics);

var UnlockAnalytics_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e16tiqpo1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var UnlockAnalytics_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e16tiqpo0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/ActivateUnify/assets/ActivateUnify@2x.png
var ActivateUnify_2x = __webpack_require__(55786);
var ActivateUnify_2x_default = /*#__PURE__*/__webpack_require__.n(ActivateUnify_2x);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/ActivateUnify/assets/ActivateUnify.webp
var ActivateUnify = __webpack_require__(75727);
var ActivateUnify_default = /*#__PURE__*/__webpack_require__.n(ActivateUnify);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/components/ActivateUnify/assets/ActivateUnify@2x.webp
var assets_ActivateUnify_2x = __webpack_require__(99475);
var assets_ActivateUnify_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ActivateUnify_2x);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/ActivateUnify/ActivateUnifyImage.tsx








var ActivateUnifyImage = function ActivateUnifyImage(_ref) {
  var alt = _ref.alt;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Elevation/* default */.Z, {
    elevation: 4,
    type: "dropShadow",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((ActivateUnify_default()), ", ").concat((assets_ActivateUnify_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "602",
        height: "560",
        src: (ActivateUnify_2x_default()),
        alt: alt
      })]
    })
  });
};

/* harmony default export */ var ActivateUnify_ActivateUnifyImage = (ActivateUnifyImage);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/ActivateUnify/ActivateUnify.tsx


function ActivateUnify_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var ActivateUnify_copy = {
  heading: "Unify customer profile data in the warehouse to Engage customers everywhere",
  description: "Deliver personalized, omnichannel campaigns to real-time targeted audiences from a centralized platform, without relying on other teams."
};
var ActivateUnify_link = {
  text: "Explore Twilio Engage Product",
  url: "/product/twilio-engage/"
};

var ActivateProfiles = function ActivateProfiles() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ActivateUnify_StyledSectionBase, {
    variant: "2Col",
    reverse: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateUnify_ActivateUnifyImage, {
        alt: "Illustration: ".concat(ActivateUnify_copy.heading)
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateUnify_StyledCopy, {
      alignSelf: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: ActivateUnify_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: ActivateUnify_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
          href: (0,getAbsoluteUrl/* default */.Z)(ActivateUnify_link.url, pageConfig),
          children: ActivateUnify_link.text
        })]
      })
    })]
  });
};

/* harmony default export */ var ActivateUnify_ActivateUnify = (ActivateProfiles);

var ActivateUnify_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e7116kl1"
} : 0)( true ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : 0);

var ActivateUnify_StyledCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e7116kl0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:440px;justify-self:end;align-self:center;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/RelatedContent/ResourceCard.tsx







var ResourceCard = function ResourceCard(_ref) {
  var href = _ref.href,
      resourceType = _ref.resourceType,
      heading = _ref.heading,
      description = _ref.description;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
    href: href,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
            variant: "outlined",
            children: resourceType
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
          tag: "h3",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Read more"
        })
      })]
    })
  });
};

/* harmony default export */ var RelatedContent_ResourceCard = (ResourceCard);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/RelatedContent/RelatedContent.tsx









var RelatedContent_copy = {
  heading: "Related content"
};
var cards = [{
  resourceType: "Blog",
  heading: "Identity Resolution Best Practices",
  description: "In part 1 of our \u2018Mastering Identity Resolution blog series' we share best practices that will simplify the complex identity management world.",
  href: "/blog/identity-resolution-best-practices-for-data-scientists/"
}, {
  resourceType: "Blog",
  heading: "The Four Biggest Pitfalls of DIY Identity Resolution",
  description: "In part 2 of our \u2018Mastering Identity Resolution blog series', we cover the four biggest pitfalls from data teams who have taken the \u2018go it alone\u2019 approach.",
  href: "/blog/four-biggest-pitfalls-of-diy-identity-resolution/"
}, {
  resourceType: "Blog",
  heading: "How Identity Resolution Lays the Foundation for Complex Customer En...",
  description: "In part 3 of our \u2018Mastering Identity Resolution blog series\u2019, we showcase how data teams can unlock powerful use cases when they move past maintenance work of identity resolution",
  href: "/blog/identity-resolution-lays-foundation-for-customer-engagement-solutions/"
}];

var RelatedContent = function RelatedContent() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RelatedContent_StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: RelatedContent_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          md: 2,
          lg: cards.length
        },
        children: cards.map(function (card) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedContent_ResourceCard, {
            href: (0,getAbsoluteUrl/* default */.Z)(card.href, pageConfig),
            resourceType: card.resourceType,
            heading: card.heading,
            description: card.description
          }, card.heading);
        })
      })
    })]
  });
};

var RelatedContent_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ezp2te80"
} : 0)(Section/* Wrapper */.im, "{max-width:1280px;margin:0 auto;padding-bottom:64px;row-gap:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{row-gap:64px;padding-bottom:160px;}}" + ( true ? "" : 0));

/* harmony default export */ var RelatedContent_RelatedContent = (RelatedContent);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/components/FaqSection/FaqSection.tsx







var faqData = [{
  question: "What is identity resolution and why is it important?",
  answer: "Identity resolution allows you to stitch together user behavior across platforms, anonymous or known state, or device, which allows you to see the entirety of a user\u2019s journey and combine their customer data into a single golden profile. It is essential for understanding customer needs and preferences, as well as creating personalized customer journeys - especially in light of the ongoing legal changes around third-party cookie tracking."
}, {
  question: "How does Unify handle identity resolution?",
  answer: "Unify resolves user identities in a deterministic manner. The Identity Graph supports multiple external IDs without any additional code. Each incoming event is analyzed, the external IDs are extracted, and then the Unify identity resolution tool algorithm matches events with profiles. A simplified version of the algorithm is as follows: Segment first searches the Identity Graph for incoming external IDs. If Segment doesn\u2019t find a matching profile, a Profile is created for that user. If Segment finds one Profile, the event is logged onto that profile. If Segment finds multiple matching profiles, Segment applies the identity resolution settings to add the event to the appropriate profile."
}];
var FaqSection_copy = {
  heading: "Frequently asked questions"
};

var FaqSection = function FaqSection() {
  var items = new Array(faqData.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        children: FaqSection_copy.heading
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* JsonLdFaq */.yD, {
        data: faqData.map(function (_ref) {
          var answer = _ref.answer,
              question = _ref.question;
          return {
            question: question,
            answer: answer
          };
        })
      }), activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                tag: "h3",
                opened: active,
                children: faqData[index].question
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: faqData[index].answer
              })
            })
          })]
        }, "item-".concat(index));
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1vv0fp71"
} : 0)("padding-bottom:28px;text-align:center;margin-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:44px;}" + ( true ? "" : 0));

var FaqSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1vv0fp70"
} : 0)("max-width:1004px;overflow-x:unset;", Section/* Wrapper */.im, "{padding-top:0;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("xs");
}, "{padding-bottom:40px;}" + ( true ? "" : 0));

/* harmony default export */ var FaqSection_FaqSection = (FaqSection);
// EXTERNAL MODULE: ./src/views/Product/UnifyPage/assets/OgUnify.png
var OgUnify = __webpack_require__(2938);
var OgUnify_default = /*#__PURE__*/__webpack_require__.n(OgUnify);
;// CONCATENATED MODULE: ./src/views/Product/UnifyPage/Unify.tsx





















var UnifyView = function UnifyView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Unify: A Complete View of Your Customer with Identity Resolution | Twilio Segment",
      pageDescription: "Segment Unify provides a complete view of your customer with deterministic identity resolution across devices, platforms and channels. Learn how Unify creates a golden profile.",
      themeColor: theme.palette.neutrals.white[100],
      bodyBackground: theme.palette.neutrals.white[100],
      pageOG: (OgUnify_default()),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LinkedProfiles_LinkedProfiles, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UseAI_UseAI, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_TrackInteractions_TrackInteractions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_GetHistory_GetHistory, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PowerPersonalization_PowerPersonalization, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UnlockAnalytics_UnlockAnalytics, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivateUnify_ActivateUnify, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedContent_RelatedContent, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FaqSection_FaqSection, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var UnifyPage_Unify = (UnifyView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "evi6lwx0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ./src/pages/product/unify.tsx



var Unify = function Unify() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UnifyPage_Unify, {});
};

/* harmony default export */ var unify = (Unify);

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 86761:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/unify",
      function () {
        return __webpack_require__(95387);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2938:
/***/ (function(module) {

module.exports = "/_next/static/images/OgUnify-1e03b39a227c111087108e6b74041985.png";

/***/ }),

/***/ 55786:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateUnify@2x-459d810f0e9dacd53e2127ed167bb63c.png";

/***/ }),

/***/ 23611:
/***/ (function(module) {

module.exports = "/_next/static/images/GetHistory@2x-af85f681cfdd9fba1381d8b760e23660.png";

/***/ }),

/***/ 95576:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-e7dc4c046cfb3177fe82a79c3ac481ce.png";

/***/ }),

/***/ 49956:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile-e85662c8d24eab8b0e88945e1337dcf2.png";

/***/ }),

/***/ 54297:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile@2x-442761fa68e4d64944ae120f6d672ff0.png";

/***/ }),

/***/ 63512:
/***/ (function(module) {

module.exports = "/_next/static/images/LinkedProfiles@2x-bf777c464f683c0025ee04e8c9f3267e.png";

/***/ }),

/***/ 5196:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerPersonalization@2x-a4cc3b72751bbc38d819cb9a1e7dde03.png";

/***/ }),

/***/ 48202:
/***/ (function(module) {

module.exports = "/_next/static/images/TrackInteractions@2x-cc2ecb1700a1607762628fec91f27050.png";

/***/ }),

/***/ 34776:
/***/ (function(module) {

module.exports = "/_next/static/images/UnlockAnalytics@2x-5b28583eb9a6aeb186ce79116dd43512.png";

/***/ }),

/***/ 224:
/***/ (function(module) {

module.exports = "/_next/static/images/UseAI@2x-1b90a14a1883901e9ddf02c22f83f71e.png";

/***/ }),

/***/ 75727:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateUnify-a13233b389708ebbef55c84610ff86e5.webp";

/***/ }),

/***/ 99475:
/***/ (function(module) {

module.exports = "/_next/static/images/ActivateUnify@2x-e078713a428366440579c7f97235eb2a.webp";

/***/ }),

/***/ 9979:
/***/ (function(module) {

module.exports = "/_next/static/images/GetHistory-18e9a793f48c1e17cf612ef7541789f9.webp";

/***/ }),

/***/ 86975:
/***/ (function(module) {

module.exports = "/_next/static/images/GetHistory@2x-9f002e0fe68b36fa059afe7e9a539248.webp";

/***/ }),

/***/ 62014:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-3008c1a1e1fb2540172a8a87dca94f25.webp";

/***/ }),

/***/ 34449:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-0f1aa91d0ad380c2435fb5d31956f1f2.webp";

/***/ }),

/***/ 56400:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile-73eccd661f3b5c1540055f3e5b89b70d.webp";

/***/ }),

/***/ 17606:
/***/ (function(module) {

module.exports = "/_next/static/images/HeroMobile@2x-89e037dad093f6628d36b3c55dd2b684.webp";

/***/ }),

/***/ 94686:
/***/ (function(module) {

module.exports = "/_next/static/images/LinkedProfiles-c29bbe39e64834caafc7a7bc9a06728e.webp";

/***/ }),

/***/ 31636:
/***/ (function(module) {

module.exports = "/_next/static/images/LinkedProfiles@2x-fac28debd9df119295d5fec825a553a5.webp";

/***/ }),

/***/ 4074:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerPersonalization-d30b08c65bf5c895c0b17e35afb611a6.webp";

/***/ }),

/***/ 81927:
/***/ (function(module) {

module.exports = "/_next/static/images/PowerPersonalization@2x-1e588c1f1682799e4bbb4394e900cc62.webp";

/***/ }),

/***/ 95638:
/***/ (function(module) {

module.exports = "/_next/static/images/TrackInteractions-deb78630e8fc2419550b282fd8bd7aae.webp";

/***/ }),

/***/ 15798:
/***/ (function(module) {

module.exports = "/_next/static/images/TrackInteractions@2x-e517c256a503e722710be0801700535d.webp";

/***/ }),

/***/ 69373:
/***/ (function(module) {

module.exports = "/_next/static/images/UnlockAnalytics-e6cc9d3c62f022c1240ae13b600964a0.webp";

/***/ }),

/***/ 18154:
/***/ (function(module) {

module.exports = "/_next/static/images/UnlockAnalytics@2x-9af89e02da63f9a6364d8b20b09d41ef.webp";

/***/ }),

/***/ 1864:
/***/ (function(module) {

module.exports = "/_next/static/images/UseAI-1345e4fc1018e47a80934cfc34d75e52.webp";

/***/ }),

/***/ 89620:
/***/ (function(module) {

module.exports = "/_next/static/images/UseAI@2x-1b90a14a1883901e9ddf02c22f83f71e.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,3996,7947,7960,6012,442,4881,2472,9774,2888,179], function() { return __webpack_exec__(86761); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);